import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { msgSetting, changeSetting } from '@blade-sxp/account/api/setting';
let default_1 = class extends Vue {
    alertMsg = 1;
    systemMsg = 1;
    type = 0;
    enable = 1;
    mounted() {
        this.msgSetting();
    }
    changeAlert(event) {
        // console.log(event);
        console.log(this.alertMsg);
        this.enable = this.alertMsg;
        this.type = 0;
        this.changeSetting();
    }
    msgSetting() {
        msgSetting()
            .then((res) => {
            this.alertMsg = res.data.data.alertMsg;
            this.systemMsg = res.data.data.systemMsg;
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    changeSystem() {
        this.enable = this.systemMsg;
        this.type = 1;
        this.changeSetting();
    }
    changeSetting() {
        changeSetting(this.enable, this.type)
            .then((res) => {
            this.$message({
                message: this.$t('statusChanged').toString(),
                type: 'success',
            });
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'msg',
        i18n: {
            messages: {
                'en-us': {
                    notification: 'notification',
                    warningMessage: 'Warning message',
                    alarmMessage: 'Alarm message notification',
                    systemInformation: 'system information',
                    suchAs: 'Such as system failure, administrator notification, etc.',
                    open: 'open',
                    close: 'close',
                    statusChanged: 'Status changed successfully',
                },
                zh: {
                    notification: '消息通知',
                    warningMessage: '告警消息',
                    alarmMessage: '布控告警消息通知',
                    systemInformation: '系统消息',
                    suchAs: '如系统故障、管理员通知等',
                    open: '开',
                    close: '关',
                    statusChanged: '状态更改成功',
                },
            },
        },
    })
], default_1);
export default default_1;
